import CarouselImages from '@/app/[locale]/product/_steps/CarouselImages';
import ChargerModelStepImage from '@/app/[locale]/product/_steps/ChargerModelStepImage';
import WizStepId from '@/app/[locale]/product/_steps/enums/WizStepId';
import FinishStepImage from '@/app/[locale]/product/_steps/FinishStepImage';
import SizeStepImage from '@/app/[locale]/product/_steps/SizeStepImage';

interface LayoutImageProps {
  readonly currentStep: WizStepId | undefined;
  readonly isAccessory: boolean;
  readonly isOuraRing4Wizard: boolean;
}

const LayoutImage = ({
  currentStep,
  isAccessory,
  isOuraRing4Wizard,
}: LayoutImageProps): JSX.Element => {
  switch (currentStep) {
    case !isOuraRing4Wizard && WizStepId.Finish:
      return <FinishStepImage />;
    case !isAccessory && WizStepId.Size:
      return <SizeStepImage />;
    case WizStepId.Accessory:
      return <ChargerModelStepImage />;
    default:
      return <CarouselImages />;
  }
};

export default LayoutImage;
